<template>
  <div class="container-fluid">
  <div v-for="attribute in errors" class="alert alert-danger" :key="attribute.field">
      {{attribute.value}}
  </div>
    <h4 class="m-3">Добавить подборку</h4>
    <el-form label-width="220px" label-position="left">
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Минимальная цена">
        <el-input v-model="form.priceFrom"></el-input>
      </el-form-item>
      <el-form-item label="Максимальная цена">
        <el-input v-model="form.priceTo"></el-input>
      </el-form-item>
      <el-form-item label="Раздел каталога">
        <el-row>
          <el-button size="small" type="primary" @click="toggleDialog()">Выбрать</el-button>
        </el-row>
        <el-row v-if="selectedSections.length">
            <el-tag
            closable
            @close="handleDeleteCat"
            >
              Выбрано: {{ selectedSections.length }}
            </el-tag>
        </el-row>
      </el-form-item>
      <el-form-item label="Сортировка">
          <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
          <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Изображение">
        <el-upload
        action=""
        list-type="picture"
        :file-list="listImages"
        :limit="1"
        :auto-upload="false"
        :on-change="(v) => handleChangeImage(v)"
        >
          <el-button size="small" type="primary">Добавить Изображение</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <popular-items v-if="form.sectionId" :section-id="form.sectionId"  :items="form.items" @changeItems="onChangeItems" />
      <el-alert v-else type="warning" show-icon :closable="false">
        <p>
          Выберите раздел каталога
        </p>
      </el-alert>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="storePreset()">Добавить</el-button>
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>

    </el-form>
      <CatalogSectionDialog
      v-if="$store.getters.showCatalogSectionDialog"
      :items-payload="selectedSections"
      @saveItems="onSaveItems"
      />
  </div>
</template>

<script>
import axios from "axios";
import PopularItems from "@/components/Popular/PopularItems";
import typeItem from "@/composable/type/filter-item.type";
import prestTypesConfig from '@/composable/config/preset-type.config.js';
import getErrors from '../../composable/utils/getErrors';
import CatalogSectionDialog from '../CatalogSectionDialog';
// import getFileList from '../../composable/utils/getFileList';

export default {
  name: "PresetCreate",
  components: {PopularItems, CatalogSectionDialog},
  data: function (){
    return {
      form: {
        id: -1,
        title: '',
        priceFrom: 0,
        priceTo: 0,
        sectionId: '',
        sort:1,
        activity: true,
        items: [],  
        image: ''      
      },
      sections: [],
      selectedSections: [],
      errors: [],
      status: 0,
      typeItem,
      prestTypesConfig,
      listImages: []
    }
  },
  methods:{
    back(){
      this.$router.go(-1);
    },
    storePreset(){      
      const props = this.getRequestProps()
      if (props) {
        axios.post('compilation/', props)
        .then(() => this.back())
        .catch((errors) => {
          if(errors.response.status === 401){
            this.$router.push('/login');
          }
          if(errors.response.status === 422) {
            this.setErrors(errors.response.data.errors)
          } else {
            this.setErrors()
          }          
        })
      }
    },
    getRequestProps() {

      const formData = new FormData();


      formData.append('title', this.form?.title || '')
      
      formData.append('activity', this.form.activity || false)
      formData.append('sort', this.form.sort || 0)

      if (this.form.priceFrom > 0 && this.form.priceTo > 0) {
        formData.append('price[min]', this.form.priceFrom)
        formData.append('price[max]', this.form.priceTo)
      }

      if (this.form.sectionId) {
        formData.append('section_id', this.form.sectionId)
      }

      if (this.form.items.length > 0) {
        let counter = 0
        this.form.items.forEach((e) => {
          e.values.forEach((el) => {
            formData.append(`options[${counter}][attribute_id]`, e.id)
            formData.append(`options[${counter}][value]`, el)
            counter += 1
          })
        })


      }

              if (this.form.image) {
         formData.append('image', this.form.image) 
        }

      return formData
    },

    setErrors(err) {
      this.errors = getErrors(err)
    },

    onChangeItems(v) {
      if (v && v.length > 0) {
        this.form.items = v;
      } else {
        this.form.items = [];
      }
    },

    toggleDialog() {
      this.$store.commit('showCatalogSectionDialog', !this.$store.getters.showCatalogSectionDialog);
    },
    setFormSection(){
      this.form.sectionId = this.selectedSections[0]?.id ?? '';
    },
    handleDeleteCat(){
      this.selectedSections = []
      this.setFormSection()
    },
    handleChangeImage(value) {
      const file = value?.raw || undefined;
      this.form.image = file
    },
    onSaveItems(items) {
      this.selectedSections = items
      this.setFormSection()
    }

  }
}
</script>

<style scoped>

</style>